<div class="TotemWidget TotemWidgetDaySurvey card {{ submitted ? 'TotemWidgetDaySurvey--Submitted' : '' }}" role="region" [attr.aria-label]="'totem-home.widgets.during-day-survey.title' | locTranslate">
    <div class="card-body">
        <div class="TotemWidgetDaySurvey-Rating mb-3" role="group" [attr.aria-label]="'totem-a11y.day-survey-rating' | locTranslate">
            @for (star of stars; track star) {
                <button
                    type="button"
                    class="btn btn-link TotemWidgetDaySurvey-Star {{ rating >= star ? 'TotemWidgetDaySurvey-Star--Active' : '' }}"
                    (click)="setRating(star)"
                    [disabled]="submitted"
                    [attr.aria-label]="'totem-a11y.day-survey-rating-value' | locTranslate:'value':star"
                    [attr.aria-pressed]="rating >= star"
                >
                    <i class="fa-{{ rating >= star ? 'solid' : 'regular' }} fa-star" aria-hidden="true"></i>
                </button>
            }
        </div>

        <div class="mb-3">
            <label class="form-label" [attr.for]="'day-survey-comment-' + id">
                {{ 'totem-widget-day-survey.comment-label' | locTranslate }}
            </label>
            <textarea
                class="form-control TotemWidgetDaySurvey-Comment"
                rows="3"
                [id]="'day-survey-comment-' + id"
                [(ngModel)]="comment"
                (ngModelChange)="onCommentChange()"
                [readonly]="submitted"
                [attr.placeholder]="'totem-widget-day-survey.comment-placeholder' | locTranslate"
            ></textarea>
        </div>

        @if (submitted) {
            <div class="TotemWidgetDaySurvey-Thanks btn btn-block btn-success pe-none">
                <i class="fa-regular fa-circle-check me-2" aria-hidden="true"></i>
                <span>{{ 'totem-widget-day-survey.thanks' | locTranslate }}</span>
            </div>
        }
        @else {
            <button type="button" class="btn btn-primary btn-block" [disabled]="!canSubmit()" (click)="submit()">
                {{ 'totem-widget-day-survey.submit' | locTranslate }}
            </button>
        }
    </div>
</div>
